import FullInfoModal from './FullInfoModal';
export default FullInfoModal;
